module.exports = __webpack_public_path__ + "static/media/sort.41c41c2c.svg";